{
  "title": "Boards",
  "graphForm": {
    "boardNameLabel": "Name the Board",
    "queryLabel": "Enter a query to graph log line counts",
    "fieldLabel": "Select a field to graph ",
    "fieldPlaceholder": "Select",
    "filterLabel": "Add a filter (optional)",
    "fieldValueLabel": "Select a field value (optional)",
    "fieldValuePlaceholder": "Select",
    "operationLabel": "Operation",
    "advancedFilteringButton": "Advanced Filtering",
    "hideAdvancedFilteringButton": "Hide Advanced Filtering",
    "addGraphButton": "Add Graph",
    "showGraphFormButton": "+ Add Graph",
    "any": "ANY"
  },
  "viewer": {
    "newBoard": "New Board",
    "boards": "Boards"
  },
  "fieldValueSelect": {
    "defaultPlaceholder": "Choose a field value...",
    "noMatchingValues": "No matching values found."
  },
  "graphBoard": {
    "plotOf": "Plot of",
    "histogramOf": "Histogram of",
    "breakdown": {
      "histogram": "Histogram",
      "donut": "Donut",
      "add": "Add a breakdown",
      "view": "View breakdowns",
      "formTitle": "Get data insights by adding a histogram or donut graph",
      "byField": "Breakdown by {{ field }}",
      "total": "Total"
    }
  },
  "subplots": {
    "noDataForField": "No data found for {{ name }}.",
    "noData": "No data found."
  }
}
